<template>
	<div class="create-user" :class="tenantId == 203 ? ' cu-type1':''">
		<span>{{ getRegUserName()}}</span>
		<div class="tooltip-b tl">
			<div class="cu-info">
				<p class="cu-info-name">
					<span>{{ $i18nUtil.trans("message.BlockCreatorInfo.creator", "생성자") }}</span>
					<span class="ell-singleline" title="">{{getRegUserName()}}</span>
			</p>
				<span class="cu-info-date">{{regDate()}}</span>
			</div>
            <!-- v-if="bdata.modUserId != null" 
                $i18nUtil.getLanguage() === 'en' && bdata.modUserNameEn !== null ? bdata.modUserNameEn : bdata.modUserName
            -->
			<div class="cu-info" v-show="(blockModUserName || bdata.modUserName) && !except">
				<p class="cu-info-name">
					<span>{{ $i18nUtil.trans("message.BlockCreatorInfo.modifier", "최종수정자") }}</span>
					<span class="ell-singleline" title="">{{getModUserName()}}</span> 
				</p>
				<span class="cu-info-date">{{modDate()}}</span>
			</div>
		</div>
	</div>
</template>

<script>
export default {
	props: {
        bdata: Object,
        blockModDate: String,
        blockRegDate: String,
        blockModUserName: String,
        blockRegUserName: String,
        modUserExceptBlocktype: String,
    },
    created (){},
    mounted() { 
        if(this.modUserExceptBlocktype == "IMAGE" ){
            this.except = true;
        }},
    data() { 
        return {
            except : false,
            tenantId: localStorage.getItem("tenantId")
        } 
    },
    computed:{},
    updated() {},
    watch: {},
    methods: {
        modDate(){
            let modDate = "";
            if(this.blockModDate == null || this.blockModDate.length == 0){ 
                modDate = this.bdata.modDate;
            }else{
                //YYYY-MM-DDTHH:mm:ss.sssZ => YYYY-MM-DD hh:mm:ss
                modDate = this.blockModDate.replace("T", " ").replace(/\..*/, '');
            }
            return modDate;
        },
        regDate(){
            let regDate = "";
            if(this.blockRegDate == null || this.blockRegDate.length == 0){
                regDate =this.bdata.regDate;
            }else{
                //YYYY-MM-DDTHH:mm:ss.sssZ => YYYY-MM-DD hh:mm:ss
                regDate = this.blockRegDate.replace("T", " ").replace(/\..*/, '');
            }
            return regDate;
        },
        getModUserName(){
            let modUserName = "";
            if(this.blockModUserName == null || this.blockModUserName.length == 0){
                modUserName = this.$i18nUtil.getLanguage() === 'en' && this.bdata.modUserNameEn !== null ? this.bdata.modUserNameEn : this.bdata.modUserName;
            }else{
                // contentBlock에서 en 체크를해서 보내줌. 
                modUserName = this.blockModUserName;
            }
            return modUserName;
        },
        getRegUserName(){
            let regUserName = "";
            if(this.blockRegUserName == null || this.blockRegUserName.length == 0){
                regUserName = this.$i18nUtil.getLanguage() === 'en' && this.regUserNameEn !== null ? this.bdata.regUserNameEn : this.bdata.regUserName;
            }else{
                // contentBlock에서 en 체크를해서 보내줌. 
                regUserName = this.blockRegUserName;
            }
            return regUserName;
        }
    }
}
</script>

<style scoped>
	/* .create-user {
		width: 155px;
	} */
</style>


// WEBPACK FOOTER //
// src/components/cowork/general/board/editor/ContentBlockCreatorInfo.vue